"use client";

import { c as _c } from "react/compiler-runtime";
import dynamic from "next/dynamic";
const Notifications = dynamic(() => import("@mantine/notifications").then(m => m.Notifications), {
  ssr: false
});
import "@mantine/notifications/styles.css";
export default function ClientNotifications() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Notifications />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}